// extracted by mini-css-extract-plugin
export default {"languageMenuItem":"LanguageMenuItem_languageMenuItem__RAIG5"};